import { IntervalPrice } from "./intervalPrice";
import { DebRepayment } from "./serviceConcept";

export class ServiceConceptData {
  edited: boolean;
  conceptServiceId: number;
  contractId: number;
  serviceConceptTypeId: number;
  name: string;
  invoiceAccountId: number;
  price: number;
  active: boolean;
  interval: boolean;
  sharedInterval: boolean;
  billable: boolean;
  monitorInvoiceAccountId: number;
  divideMonitor: boolean;
  percentMonitor: number;
  scaledAccount: boolean;
  scalingPerDay: boolean;
  groupedConcept: number;
  invoiceNumber: number;
  redeemable: boolean;
  unitInInvoice: boolean;
  order: number;
  dailyGratuities: number;
  intervalPrices: IntervalPrice[];
  debRepayments: DebRepayment[];
}

export class UpdatedServiceConceptData {
  conceptServiceId: number;
  serviceConceptTypeId: number;
  name: string;
  invoiceAccountId: number;
  price: number;
  active: boolean;
  interval: boolean;
  sharedInterval: boolean;
  billable: boolean;
  monitorInvoiceAccountId: number;
  divideMonitor: boolean;
  percentMonitor: number;
  scaledAccount: boolean;
  scalingPerDay: boolean;
  groupedConcept: number;
  invoiceNumber: number;
  redeemable: boolean;
  unitInInvoice: boolean;
  order: number;
  dailyGratuities: number;
  intervalPrices: IntervalPrice[];
  debRepayments: DebRepayment[];
}
